/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';
import { FSF_PAGES } from './fsfPages.generated';
import BlockRenderer from './components/BlockRenderer';
import FsfHero from './components/FsfHero';
import PageLinks from './components/PageLinks';
import { DEFAULT_PAGE } from './data/siteData';
import AboutPageSections from './pages/AboutPageSections';
import ContactPageSections from './pages/ContactPageSections';
import CorporateSocialResponsibilityPageSections from './pages/CorporateSocialResponsibilityPageSections';
import EthicsPageSections from './pages/EthicsPageSections';
import GlobalNetworkPageSections from './pages/GlobalNetworkPageSections';
import HomePageSections from './pages/HomePageSections';
import LogisticsPageSections from './pages/LogisticsPageSections';
import MovingPageSections from './pages/MovingPageSections';
import QualityPageSections from './pages/QualityPageSections';
import { isImportedFooterBlock } from './utils/content';

const PAGE_SECTION_COMPONENTS = {
  'about-us': AboutPageSections,
  'our-ethics-values-culture': EthicsPageSections,
  'quality-assurance-control': QualityPageSections,
  'global-network': GlobalNetworkPageSections,
  logistics: LogisticsPageSections,
  moving: MovingPageSections,
  'corporate-social-responsibility-2': CorporateSocialResponsibilityPageSections,
  contactus: ContactPageSections,
};

function DefaultPageSections({ blocks, links }) {
  return (
    <>
      <div className="fsf-page__content">
        {blocks.map((block, index) => (
          <BlockRenderer key={`${block.type}-${index}`} block={block} index={index} />
        ))}
      </div>
      <PageLinks links={links} />
    </>
  );
}

export default function FsfPageApp({ pageSlug = DEFAULT_PAGE }) {
  const page = FSF_PAGES[pageSlug] || FSF_PAGES[DEFAULT_PAGE];
  const isHome = pageSlug === DEFAULT_PAGE || page.slug === DEFAULT_PAGE;
  const blocks = (page.blocks || []).filter((block) => !isImportedFooterBlock(block));
  const PageSections = isHome ? HomePageSections : PAGE_SECTION_COMPONENTS[page.slug];

  return (
    <article className={`fsf-page fsf-page--${page.slug}`}>
      <FsfHero page={page} isHome={isHome} />
      <div className="fsf-page__body">
        {PageSections ? (
          <PageSections page={page} />
        ) : (
          <DefaultPageSections blocks={blocks} links={page.links} />
        )}
      </div>
    </article>
  );
}
